import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideNotification } from '../store/slices/NotificationSystemSlice';
import notifSuccess from '../assets/notifsuccess.svg';
import notifFailure from '../assets/notiffailure.svg';

const positionStyles = {
  'top-right': { top: 20, right: 20, left: 'auto', bottom: 'auto' },
  'top-left': { top: 20, left: 20, right: 'auto', bottom: 'auto' },
  'bottom-right': { bottom: 20, right: 20, left: 'auto', top: 'auto' },
  'bottom-left': { bottom: 20, left: 20, right: 'auto', top: 'auto' },
  'top-center': { top: 20, left: '50%', transform: 'translateX(-50%)', right: 'auto', bottom: 'auto' },
  'bottom-center': { bottom: 20, left: '50%', transform: 'translateX(-50%)', right: 'auto', top: 'auto' },
};

const NotificationSystem = () => {
  const dispatch = useDispatch();
  const { open, message, success, duration, position } = useSelector(state => state.notification);

  useEffect(() => {
    if (open && duration > 0) {
      const timer = setTimeout(() => dispatch(hideNotification()), duration);
      return () => clearTimeout(timer);
    }
  }, [open, duration, dispatch]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 9999,
        minWidth: 320,
        maxWidth: 400,
        padding: 10,
        borderRadius: '4px',
        border: '0.936px solid rgba(255, 255, 255, 0.20)',
        background: 'rgba(26, 29, 33, 0.40)',
        display: 'flex',
        alignItems: 'center',
        gap: 20,
        ...positionStyles[position],
      }}
      onClick={() => dispatch(hideNotification())}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={success ? notifSuccess : notifFailure}
          alt={success ? 'Success' : 'Failure'}
          style={{ width: 48, height: 48 }}
        />
      </div>
      <span style={{
        color: '#FFF',
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '24px', /* 150% */
        letterSpacing: '-0.5px',
      }}>{message}</span>
    </div>
  );
};

export default NotificationSystem; 